import ProjectLicense from './ProjectLicense'
export default class LuLicenseType {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //Description is required
      Description: '',
      //IsActive is required
      IsActive: false,
      SortOrder: null,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.Description =  obj.Description
    this.IsActive = obj.IsActive
    this.SortOrder = obj.SortOrder

    this.ProjectLicense = []
    if (obj.ProjectLicense) {
      obj.ProjectLicense.forEach((item) => {
        this.ProjectLicense.push(new ProjectLicense(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.ProjectLicense = []
    if (this.ProjectLicense) {
      this.ProjectLicense.forEach((item) => {
        obj.ProjectLicense.push(item.removeRelated())
      })
    }
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.ProjectLicense = null
    return obj
  }
}
